import type { ProblemDetails } from '@/lib/api/errors';

export type BillingProblemKind = 'plan-limit' | 'plan-required' | 'ai-allowance-exhausted' | 'billing-unavailable';
export interface BillingProblem {
  kind: BillingProblemKind;
  requiredTier?: 'library' | 'pro';
  /** The plan whose limit was reached (plan-limit). */
  tier?: 'free' | 'library' | 'pro';
  limit?: number;
  periodEnd?: string;
}

const listeners = new Set<(problem: BillingProblem) => void>();

export function reportBillingProblem(status: number, problem?: ProblemDetails): void {
  if (typeof problem?.type !== 'string' || !problem.type.startsWith('urn:knowsh:problem:')) return;
  const kind = problem.type.replace('urn:knowsh:problem:', '');
  if (!(status === 402 && ['plan-limit', 'plan-required', 'ai-allowance-exhausted'].includes(kind ?? '')) &&
      !(status === 503 && kind === 'billing-unavailable')) return;
  const notice: BillingProblem = {
    kind: kind as BillingProblemKind,
    requiredTier: problem?.requiredTier === 'library' || problem?.requiredTier === 'pro' ? problem.requiredTier : undefined,
    tier: problem?.tier === 'free' || problem?.tier === 'library' || problem?.tier === 'pro' ? problem.tier : undefined,
    limit: typeof problem?.limit === 'number' ? problem.limit : undefined,
    periodEnd: typeof problem?.periodEnd === 'string' ? problem.periodEnd : undefined,
  };
  listeners.forEach((listener) => listener(notice));
}

export function onBillingProblem(listener: (problem: BillingProblem) => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
